"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React, { useContext, useRef, useState } from "react";
import { Form as ReactFinalFormComponent, Field, FormSpy as ReactFinalFormSpy } from "react-final-form";
import { FORM_ERROR } from "final-form";
import setFieldData from "final-form-set-field-data";
import classNames from "classnames";
import { cloneDeep, identity, isEmpty } from "lodash";
import Button, { ButtonState } from "../Button/Button";
import { SegmentedControl, SegmentedControlOption } from "../SegmentedControl/SegmentedControl";
import { Select } from "../Select";
import TextInput from "../TextInput/TextInput";
import { mapTextInputProps, mapSegmentedControlProps, mapSelectProps, mapCheckboxProps } from "./mapFormProps";
import { getTextInputSize, getSegmentedControlSize, getSelectSize, getButtonSize, getCheckboxSize } from "./mapFormSizes";
import { Checkbox } from "../Checkbox/Checkbox";
export var FormContext = React.createContext(null);
export var ValidationSpy = function ValidationSpy(_ref) {
  var mutators = _ref.mutators,
    name = _ref.name;
  return /* @__PURE__ */React.createElement(ReactFinalFormSpy, {
    subscription: {
      active: true,
      modified: true,
      hasValidationErrors: true,
      errors: true
    },
    onChange: function onChange(data) {
      var _a, _b;
      var isActiveField = data.active === name;
      if (!isActiveField && data.modified && data.modified[name] && ((_a = data.errors) == null ? void 0 : _a[name])) {
        mutators == null ? void 0 : mutators["setFieldData"](name, {
          showValidationErrors: true
        });
      }
      if (!((_b = data.errors) == null ? void 0 : _b[name])) {
        mutators == null ? void 0 : mutators["setFieldData"](name, {
          showValidationErrors: false
        });
      }
    }
  });
};
export var FormTextInput = function FormTextInput(props) {
  var _a;
  var context = useContext(FormContext);
  var size = getTextInputSize(context == null ? void 0 : context.fieldSize);
  var focus = (_a = context == null ? void 0 : context.form) == null ? void 0 : _a.focus;
  var name = props.name,
    autoFocus = props.autoFocus;
  React.useEffect(function () {
    if (autoFocus) {
      focus == null ? void 0 : focus(name);
    }
  }, [autoFocus, name, focus]);
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Field, __spreadValues({
    className: "form-v2__field",
    initialValue: "",
    parse: identity
  }, props), mapTextInputProps(function (fieldProps) {
    return /* @__PURE__ */React.createElement(TextInput, __spreadValues({
      size: size
    }, fieldProps));
  })), /* @__PURE__ */React.createElement(ValidationSpy, {
    name: props.name,
    mutators: context == null ? void 0 : context.mutators
  }));
};
export var FormSegmentedControl = function FormSegmentedControl(_a) {
  var _b = _a,
    options = _b.options,
    props = __objRest(_b, ["options"]);
  var context = useContext(FormContext);
  var size = getSegmentedControlSize(context == null ? void 0 : context.fieldSize);
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Field, __spreadValues({
    parse: identity,
    className: "form-v2__field"
  }, props), mapSegmentedControlProps(function (fieldProps) {
    return /* @__PURE__ */React.createElement(SegmentedControl, __spreadProps(__spreadValues({}, fieldProps), {
      size: size
    }), options.map(function (option) {
      return /* @__PURE__ */React.createElement(SegmentedControlOption, __spreadValues({
        key: option.value.toString()
      }, option));
    }));
  })), /* @__PURE__ */React.createElement(ValidationSpy, {
    name: props.name,
    mutators: context == null ? void 0 : context.mutators
  }));
};
export var FormCheckbox = function FormCheckbox(_ref2) {
  var name = _ref2.name,
    initialValue = _ref2.initialValue,
    validate = _ref2.validate,
    label = _ref2.label,
    children = _ref2.children,
    labelHidden = _ref2.labelHidden;
  var context = useContext(FormContext);
  var size = getCheckboxSize(context == null ? void 0 : context.fieldSize);
  var ariaLabelledBy = "checkbox-error";
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Field, {
    name: name,
    type: "checkbox",
    parse: identity,
    initialValue: initialValue != null ? initialValue : false,
    validate: validate
  }, function (fieldProps) {
    var error = mapCheckboxProps(fieldProps);
    return /* @__PURE__ */React.createElement("div", {
      className: "checkbox-container"
    }, /* @__PURE__ */React.createElement(Checkbox, {
      checked: !!fieldProps.input.checked,
      id: name,
      label: children || label,
      labelHidden: labelHidden,
      size: size,
      error: error,
      onChange: function onChange() {
        var next = fieldProps.input.checked !== void 0 ? !fieldProps.input.checked : true;
        fieldProps.input.onChange(next);
        fieldProps.input.onBlur();
      },
      onFocus: fieldProps.input.onFocus
    }));
  }), /* @__PURE__ */React.createElement(ValidationSpy, {
    name: name,
    mutators: context == null ? void 0 : context.mutators
  }));
};
export var FormSelect = function FormSelect(props) {
  var context = useContext(FormContext);
  var size = getSelectSize(context == null ? void 0 : context.fieldSize);
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Field, __spreadValues({
    parse: identity,
    className: "form-v2__field"
  }, props), mapSelectProps(function (fieldProps) {
    return /* @__PURE__ */React.createElement(Select, __spreadValues({
      size: size
    }, fieldProps), props.children);
  })), /* @__PURE__ */React.createElement(ValidationSpy, {
    name: props.name,
    mutators: context == null ? void 0 : context.mutators
  }));
};
export var FormSubmitButton = function FormSubmitButton(_c) {
  var _d = _c,
    children = _d.children,
    className = _d.className,
    rest = __objRest(_d, ["children", "className"]);
  var context = useContext(FormContext);
  var size = getButtonSize(context == null ? void 0 : context.fieldSize);
  var buttonState;
  if (rest.buttonState) {
    buttonState = rest.buttonState;
  } else {
    buttonState = (context == null ? void 0 : context.submitting) ? ButtonState.Waiting : ButtonState.Idle;
  }
  return /* @__PURE__ */React.createElement(Button, __spreadProps(__spreadValues({}, rest), {
    className: classNames("form-v2__submit-button", className),
    buttonState: buttonState,
    size: size
  }), children);
};
export var FormComponent = React.forwardRef(function (_e, ref) {
  var _f = _e,
    onSubmit = _f.onSubmit,
    fieldSize = _f.fieldSize,
    className = _f.className,
    children = _f.children,
    _f$shakeOnError = _f.shakeOnError,
    shakeOnError = _f$shakeOnError === void 0 ? true : _f$shakeOnError,
    customDataAttributes = __objRest(_f, ["onSubmit", "fieldSize", "className", "children", "shakeOnError"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shaking = _useState2[0],
    setShaking = _useState2[1];
  var shake = function shake() {
    setShaking(false);
    window.requestAnimationFrame(function () {
      setShaking(true);
    });
  };
  var handleSubmit = function handleSubmit(values) {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var submissionResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onSubmit(values);
          case 2:
            submissionResult = _context.sent;
            if (submissionResult && shakeOnError) {
              shake();
            }
            return _context.abrupt("return", submissionResult);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  return /* @__PURE__ */React.createElement(ReactFinalFormComponent, {
    onSubmit: handleSubmit,
    mutators: {
      setFieldData: setFieldData
    },
    destroyOnUnregister: true
  }, function (_ref3) {
    var handleSubmit2 = _ref3.handleSubmit,
      submitError = _ref3.submitError,
      submitting = _ref3.submitting,
      form = _ref3.form,
      values = _ref3.values,
      errors = _ref3.errors;
    return /* @__PURE__ */React.createElement(FormContext.Provider, {
      value: {
        submitError: submitError,
        submitting: submitting,
        fieldSize: fieldSize,
        mutators: form.mutators,
        values: values,
        form: form
      }
    }, /* @__PURE__ */React.createElement("form", __spreadProps(__spreadValues({
      ref: ref,
      onSubmit: function onSubmit(ev) {
        for (var key in values) {
          form.mutators["setFieldData"](key, {
            showValidationErrors: true
          });
        }
        if (!isEmpty(errors) && shakeOnError) {
          shake();
        }
        handleSubmit2(ev);
      }
    }, customDataAttributes), {
      className: classNames("form-v2__form", _defineProperty({}, "form-v2__form--has-error", shaking), className)
    }), children));
  });
});
export var createFormSubmitErrorObject = function createFormSubmitErrorObject(submitErrorMessage) {
  var fieldErrorMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __spreadValues(_defineProperty({}, FORM_ERROR, submitErrorMessage), fieldErrorMessages);
};
export var OnFieldValueChangeSpy = function OnFieldValueChangeSpy(props) {
  var activeField = useRef(null);
  var storedValues = useRef(null);
  return /* @__PURE__ */React.createElement(ReactFinalFormSpy, {
    subscription: {
      active: true,
      errors: true,
      values: true
    },
    onChange: function onChange(form) {
      var _a, _b, _c, _d, _e, _f;
      if (form.active && form.active === activeField.current) {
        return;
      }
      for (var _i = 0, _Object$entries = Object.entries(form.values); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          fieldName = _Object$entries$_i[0],
          fieldValue = _Object$entries$_i[1];
        if (storedValues.current !== null && ((_a = storedValues.current) == null ? void 0 : _a[fieldName]) !== void 0 && ((_b = storedValues.current) == null ? void 0 : _b[fieldName]) !== fieldValue) {
          var errorMessage = void 0;
          if (((_c = form.errors) == null ? void 0 : _c[fieldName]) && ((_d = storedValues.current) == null ? void 0 : _d[fieldName])) {
            errorMessage = (_e = form.errors) == null ? void 0 : _e[fieldName];
          }
          props.onChange(fieldName, errorMessage);
        }
      }
      storedValues.current = form.values ? cloneDeep(form.values) : null;
      if (form.active !== activeField.current) {
        activeField.current = (_f = form.active) != null ? _f : null;
      }
    }
  });
};
export var OnSubmitFailedSpy = function OnSubmitFailedSpy(props) {
  return /* @__PURE__ */React.createElement(ReactFinalFormSpy, {
    subscription: {
      errors: true,
      submitFailed: true,
      modifiedSinceLastSubmit: true
    },
    onChange: function onChange(_ref4) {
      var errors = _ref4.errors,
        submitFailed = _ref4.submitFailed,
        modifiedSinceLastSubmit = _ref4.modifiedSinceLastSubmit;
      if (!modifiedSinceLastSubmit && submitFailed) {
        props.onSubmitFailed(errors != null ? errors : void 0);
      }
    }
  });
};